<template>
  <div
      class="flex flex-col items-center justify-start max-w-screen-xl w-full pt-4 pb-12"
  >
    <!-- Dropdown Buttons -->
    <div class="flex flex-row flex-wrap items-center w-full select-none mb-2">
      <div
          v-for="newsPostCategory in newsPostCategories"
          :key="newsPostCategory.id"
          class="text-semibold px-4 py-2 hover:bg-a-secondary hover:text-white text-a-secondary cursor-pointer transition duration-200 ease-in-out rounded-sm"
          @click="gotoSelectedNewsPostCategoryPage(newsPostCategory)"
      >
        <p class="text-sm">
          {{ newsPostCategory.title }}
        </p>
      </div>
      <div
          class="flex flex-row text-semibold px-4 py-2 border-b-2 border-transparent hover:border-a-secondary cursor-pointer transition duration-200 ease-in-out"
          :class="
          isShowingNewsAnnouncementCategories
            ? 'border-a-secondary'
            : 'border-transparent'
        "
          @click="toggleNewsAnnouncementCategoriesMenuVisibility"
      >
        <span class="text-sm">Announcement Categories</span>
        <Icon
            :name="            isShowingNewsAnnouncementCategories
              ? 'mdi:chevron-up'
              : 'mdi:chevron-down'"
            class="text-xl"
        />
      </div>
    </div>
    <!-- Dropdown Buttons End -->
    <!-- Dropdown Menus  -->
    <div
        class="flex w-full px-4 pt-4"
        v-show="isShowingNewsAnnouncementCategories"
    >
      <div class="grid grid-cols-3 md:grid-cols-4 w-full">
        <div
            class="flex flex-col w-full py-4 text-center"
            v-for="newsAnnouncementCategory in newsAnnouncementCategories"
            :key="newsAnnouncementCategory.id"
        >
          <span
              @click="
              searchNewsAnnouncementsForCategory(newsAnnouncementCategory)
            "
              class="font-semibold cursor-pointer hover:text-a-secondary pb-1 text-sm"
          >
            {{ newsAnnouncementCategory.title }}
          </span>
        </div>
      </div>
      <!-- Dropdown Menus End -->
    </div>
    <!-- Hero Section -->
    <div
        class="flex flex-col md:flex-row w-full h-auto md:h-160"
    >
      <div class="w-full md:w-2/3 h-56 md:h-full min-h-full">
        <NewsPostGrid
            :newsPosts="topNewsPosts as NewsHomeNewsPostListItem[]"
            v-if="topNewsPosts?.length > 0"
        />
        <div
            v-else
            class="flex flex-row items-center justify-center bg-a-neutral-lightest text-white h-full text-center rounded-xl"
        >
          <p>No top story for now.</p>
        </div>
      </div>
      <div class="flex flex-col w-full my-2 md:my-0 md:w-1/3 px-2 h-full min-h-full">
        <h3 class="text-md border-b-2 border-a-secondary mb-1 font-semibold">
          Top Announcements
        </h3>
        <div
            class="flex flex-col w-full"
            v-if="topNewsAnnouncements?.length > 0"
        >
          <NewsAnnouncementHomeTopCard
              v-for="topAnnouncement in topNewsAnnouncements as NewsHomeNewsAnnouncementListItem[]"
              :key="topAnnouncement.slug"
              :newsAnnouncement="topAnnouncement"
          />
        </div>
        <div
            class="flex flex-row items-center justify-center bg-a-neutral-lightest text-white h-full text-center rounded-sm"
            v-else
        >
          <p>No top announcement for now</p>
        </div>
      </div>
    </div>
    <!-- Hero Section Ends -->
    <!-- Page Content -->
    <div class="flex flex-col w-full px-2 md:px-0">
      <div class="flex flex-row items-center justify-between bg-a-secondary text-white text-xl px-2 py-1 rounded-sm mt-4 mb-2">
        <p
        >
          Top Stories By Category
        </p>
        <nuxt-link
            :to="{name:'news-stories'}"
            class="flex flex-row items-center justify-center text-sm hover:underline"
        >
          <p>Explore More</p>
          <Icon
              name="mdi:chevron-right"
              class="text-xl"
          />
        </nuxt-link>
      </div>
      <NewsTopPostsByCategoriesGrid
          :newsPostsByCategories="topNewsPostsByCategories as NewsHomeCategorizedNewsPosts[]"
      />
    </div>
    <div class="flex flex-col w-full my-16">
      <div class="flex flex-row items-center justify-between bg-a-secondary text-white text-xl px-2 py-1 rounded-sm mt-4 mb-2">

        <p>
          Latest Announcements
        </p>
        <nuxt-link
            :to="{name:'news-announcements'}"
            class="flex flex-row items-center justify-center text-sm hover:underline"
        >
          <p>Explore More</p>
          <Icon
              name="mdi:chevron-right"
              class="text-xl"
          />
        </nuxt-link>
      </div>
      <div class="grid grid-cols-2 md:grid-cols-5 gap-x-4 gap-y-10">
        <NewsAnnouncementHomeLatestCard
            v-for="newsAnnouncement in latestNewsAnnouncements"
            :key="newsAnnouncement.slug"
            :newsAnnouncement="newsAnnouncement"
        />
      </div>
    </div>
    <div class="flex flex-col w-full my-16">
      <p
          class="bg-a-secondary text-white text-xl px-2 py-1 rounded-sm mt-4 mb-2"
      >
        All News Announcements
      </p>
      <template
          v-if="
          newsAnnouncementPages.length > 0 &&
          (newsAnnouncementPages[0].featured_news_announcements.length > 0 ||
            newsAnnouncementPages[0].non_featured_news_announcement.length > 0)
        "
      >
        <div
            class="grid grid-cols-2 md:grid-cols-5 gap-x-4 gap-y-10"
            v-for="newsAnnouncementPage in newsAnnouncementPages"
            :key="newsAnnouncementPage.page_number"
        >
          <NewsAnnouncementHomeCard
              style="min-height: 300px; height: auto"
              v-for="featuredNewsAnnouncement in newsAnnouncementPage.featured_news_announcements"
              :key="featuredNewsAnnouncement.slug"
              :newsAnnouncement="featuredNewsAnnouncement"
              @click.native="gotoNewsAnnouncementPage(featuredNewsAnnouncement)"
          />
          <NewsAnnouncementHomeCard
              style="min-height: 300px; height: auto"
              v-for="newsAnnouncement in newsAnnouncementPage.non_featured_news_announcement"
              :key="newsAnnouncement.id"
              :newsAnnouncement="newsAnnouncement"
              @click.native="gotoNewsAnnouncementPage(newsAnnouncement)"
          />
        </div>
      </template>
      <template v-else>
        <div
            class="flex flex-col w-full items-center justify-center h-64 bg-a-neutral-dim rounded text-a-neutral-light"
        >
          <Icon
              name="mdi:package-variant"
              class="text-6xl"
          />
          <p class="text-lg">No Announcement Exists at this time</p>
          <p class="text-base">
            Please come back in a few moments...we will try our best to have
            something for you
          </p>
        </div>
      </template>
      <div class="flex flex-row items-center justify-center">
        <BaseButton
            @click.native="loadNewsAnnouncementsFromNextPage()"
            v-if="nextPageLink"
            :loading="showLoadingNextPage"
            loadingSize="7px"
            loadingColor="#212427"
            :showLoadingText="showLoadingNextPage"
            loadingText="Loading More Announcements..."
            :tailwindClasses="[
            'my-8 rounded text-md border-2 border-a-primary',
            showLoadingNextPage
              ? 'bg-a-primary text-a-neutral-darkest pointer-events-none'
              : 'hover:bg-a-primary text-a-neutral-darkest',
          ]"
        >
          Load More
          <Icon name="mdi:chevron-double-down"/>
        </BaseButton>
      </div>
    </div>
    <!-- Page Content Ends-->
  </div>
</template>

<script
    setup
    lang="ts"
>
import {definePageMeta, useNewsDataManager} from "#imports";
import {useMainNewsDataManager} from "~/composables/useMainNewsDataManager";
import type {
  NewsHomeCategorizedNewsPosts,
  MainNewsAnnouncementPage,
  MainNewsAnnouncementsData, NewsAnnouncement, NewsHomeNewsPostListItem, NewsHomeNewsAnnouncementListItem
} from "~/types";
import type {GeoLocation} from "~/types/geodata";

definePageMeta({
  layout: 'main-news'
})

useHead({
  title: 'News Home'
})

const newsDataManager = useNewsDataManager();
const newsMainDataManager = useMainNewsDataManager();
const newsStore = useNews();
const searchStore = useSearch();

const newsPostCategories = await newsDataManager.getNewsPostCategories();
const newsAnnouncementCategories = await newsDataManager.getNewsAnnouncementCategories()
const newsHomeData = await newsMainDataManager.getMainNews();

const topNewsPosts = computed(() => {
  return newsHomeData?.top_stories;
})

const topNewsAnnouncements = computed(() => {
  return newsHomeData?.top_news_announcements;
})

const topNewsPostsByCategories = computed(() => {
  return newsHomeData?.top_stories_by_categories;
})

const latestNewsAnnouncements = computed(() => {
  return newsHomeData?.latest_news_announcements;
})

const isShowingNewsPostCategories = ref(false);
const isShowingNewsAnnouncementCategories = ref(false);

const mainNewsAnnouncementsData = ref<MainNewsAnnouncementsData | null>(null);
const newsAnnouncementPages = ref<MainNewsAnnouncementPage[]>([]);
const nextPageLink = ref('');
const prevPageLink = ref('');
const showLoadingNextPage = ref(false);

mainNewsAnnouncementsData.value = await newsMainDataManager.getMainNewsAnnouncements() as MainNewsAnnouncementsData;

newsAnnouncementPages.value.push(mainNewsAnnouncementsData.value?.news_announcement_page as MainNewsAnnouncementPage);
nextPageLink.value = mainNewsAnnouncementsData.value?.pagination_links.next as string;
prevPageLink.value = mainNewsAnnouncementsData.value?.pagination_links.prev as string;

const currentSearchLocation = computed(() => {
  return searchStore.current_search_location;
});

const defaultQueryParams = computed(() => {
  return {
    r: searchStore.current_search_radius,
    sort: searchStore.current_news_sort_filter_id,
    l: (currentSearchLocation as GeoLocation).place_name,
    cp: btoa(`${(currentSearchLocation as GeoLocation).geometry.coordinates[0]},${(currentSearchLocation as GeoLocation).geometry.coordinates[1]}`)
  };
});

function gotoNewsAnnouncementPage(announcement) {
  navigateTo({
    name: "news-announcements",
    params: {
      slug: announcement.slug
    }
  });
}

function gotoSelectedNewsPostCategoryPage(category) {
  navigateTo({
    name: "news-stories",
    query: {category: category.slug},
  });
}

function showNewsAnnouncementCategoriesMenu() {
  isShowingNewsAnnouncementCategories.value = true;
  isShowingNewsPostCategories.value = false;
}

function showNewsPostCategoriesMenu() {
  isShowingNewsPostCategories.value = true;
  isShowingNewsAnnouncementCategories.value = false;
}

function toggleNewsPostCategoriesMenuVisibility() {
  isShowingNewsPostCategories.value = !isShowingNewsPostCategories.value;
  isShowingNewsAnnouncementCategories.value = false;
}

function toggleNewsAnnouncementCategoriesMenuVisibility() {
  isShowingNewsAnnouncementCategories.value =
      !isShowingNewsAnnouncementCategories.value;
  isShowingNewsPostCategories.value = false;
}

function searchNewsAnnouncementsForCategory(category) {
  searchStore.setSearchQuery(category.title)
  navigateTo({
    name: "news-announcements-search",
    query: {
      c: category.title,
      ...defaultQueryParams.value,
    },
  });
}

async function loadNewsAnnouncementsFromNextPage() {
  showLoadingNextPage.value = true;
  showLoadingNextPage.value = true;
  let response = await newsMainDataManager.getMainNewsAnnouncementsFromUrl(nextPageLink.value as string);
  if (response) {
    newsAnnouncementPages.value.push(response.news_announcement_page as MainNewsAnnouncementPage);
    nextPageLink.value =
        response.pagination_links.next as string;
    prevPageLink.value =
        response.pagination_links.prev as string;
  }
  showLoadingNextPage.value = false;
}

</script>

<style></style>
